/**
 * Checks if an error is a free trial limitation error
 * @param error - The error object from axios/API call
 * @returns Object with isLimitationError flag and parsed message/type
 */
export const checkLimitationError = (error: any): {
  isLimitationError: boolean
  message?: string
  type?: 'timetable' | 'exam'
} => {
  // Check if it's a 400 Bad Request
  if (error?.response?.status === 400) {
    const message = error.response.data?.message || ''
    
    // Check if message contains "free trial limit"
    if (message.includes('free trial limit')) {
      // Determine type from message
      const type = message.includes('timetable') ? 'timetable' : 'exam'
      return {
        isLimitationError: true,
        message,
        type,
      }
    }
  }
  
  // Also check for axios error format
  if (error?.response?.status === 400) {
    const message = error?.response?.data?.message || error?.message || ''
    if (message.includes('free trial limit')) {
      const type = message.includes('timetable') ? 'timetable' : 'exam'
      return {
        isLimitationError: true,
        message,
        type,
      }
    }
  }
  
  return { isLimitationError: false }
}




